import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PageEvent, MatPaginator } from '@angular/material/paginator';
import {
  MatTableDataSource,
  MatTable,
  MatColumnDef,
  MatHeaderCellDef,
  MatHeaderCell,
  MatCellDef,
  MatCell,
  MatHeaderRowDef,
  MatHeaderRow,
  MatRowDef,
  MatRow,
} from '@angular/material/table';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { IndexTemplateComponent } from '@bisual/ngx-index-template';
import { MeetingRecord } from 'src/app/models/meeting-record.interface';
import { CompanyProduct } from 'src/app/models/company_product.model';
import { ApiService } from 'src/app/services/api.service';
import { UtilsService } from 'src/app/services/utils.service';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatFormField, MatSuffix, MatPrefix } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { DatePipe } from '@angular/common';
import { UsersPreviewPipe } from 'src/app/pipes/users-preview.pipe';
import { CompanyProductPageIdentityComponent } from '../company-product-page-identity/company-product-page-identity.component';

@Component({
  selector: 'app-company-product-meeting-records',
  templateUrl: './company-product-meeting-records.component.html',
  styleUrls: ['./company-product-meeting-records.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MatButton,
    RouterLink,
    MatIcon,
    FormsModule,
    ReactiveFormsModule,
    MatPaginator,
    MatFormField,
    MatInput,
    MatIconButton,
    MatSuffix,
    MatTable,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    MatMenuTrigger,
    MatMenu,
    MatMenuItem,
    MatPrefix,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow,
    DatePipe,
    UsersPreviewPipe,
    CompanyProductPageIdentityComponent,
  ],
})
export class CompanyProductMeetingRecordsComponent extends IndexTemplateComponent {
  private api = inject(ApiService);

  protected readonly page_title = inject(ActivatedRoute).snapshot.title;

  company_product_id: string = null as any;

  displayedColumns: string[] = ['title', 'date', 'assistants', 'actions'];

  readonly assistantsPreviewVisibleCount = 3;
  dataSource: MatTableDataSource<MeetingRecord> = new MatTableDataSource<MeetingRecord>();
  filterForm: UntypedFormGroup;

  constructor() {
    super(inject(Router), inject(UntypedFormBuilder), inject(ActivatedRoute), inject(UtilsService));
  }

  override ngOnInit(): void {
    this.company_product_id = this.activatedRoute.parent?.snapshot.parent?.paramMap.get('id') as string;
    super.ngOnInit();
  }

  override fetchData() {
    this.api
      .getCompanyProductMeetingRecords(this.company_product_id, {
        ...this.filterForm.value,
        order_by: 'date:desc',
        with: 'users..role',
      })
      .subscribe(data => {
        this.dataSource.data = data.data;
        this.setMetadata(+data.meta.total, data.meta.current_page - 1, data.meta.per_page);
      });
  }

  deleteMeetingRecord(meetingRecordId: any) {
    if (confirm('¿Estás seguro de que quieres eliminar el acta?')) {
      this.api.deleteMeetingRecord(meetingRecordId).subscribe(data => {
        this.fetchData();
      });
    }
  }
}
